import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CompanyDataProps } from "../types/type";
import {
  registeredCompanies,
} from "../../pages/dashboard/hooks/useDashboard";
import { isUserAuthenticated } from "../utils/authUser";

const useQRCodeRedirect = () => {
  const [companyDetails, setCompanyDetails] = useState<CompanyDataProps | null>(
    null
  );
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const location = useLocation();
  const [companyId, setCompanyId] = useState<string | null>(null);
  const navigate = useNavigate();
  const path = location.pathname;

  const checkIfUserAuthenticated = async () => {
    const userAuthenticated = await isUserAuthenticated();
    setIsAuthenticated(userAuthenticated);
  };

  useEffect(() => {
    const getQueryParam = (param: any) => {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(param);
    };
    
    const id = getQueryParam('qrcode-companyid');
    setCompanyId(id);
    
    // Optional: Listen for URL changes
    const handleUrlChange = () => {
      const newId = getQueryParam('qrcode-companyid');
      setCompanyId(newId);
    };
    
    window.addEventListener('popstate', handleUrlChange);
    
    return () => {
      window.removeEventListener('popstate', handleUrlChange);
    };
  }, []);

  useEffect(() => {
    checkIfUserAuthenticated();
  }, [isUserAuthenticated]);

  useEffect(() => {
    if (companyId) {
      const selectedCompany = registeredCompanies.find(
        (company) => company.companyId === companyId
      );
      if (selectedCompany) {
        setCompanyDetails(selectedCompany);
        if (isAuthenticated) {
          navigate(`/dashboard?qrcode-companyid=${companyId}`);
        }
      }
    }

    if(!isAuthenticated){
      if (path === "/login" || path === "/register"){
        navigate(path);
      }
    }
  }, [companyId, isAuthenticated]);

  const handleRedirectUserToOutgoingCallScreen = () => {
    if (companyDetails) {
     navigate(`/dashboard?qrcode-companyid=${companyDetails.companyId}`);
    }
  };

  return {
    companyId,
    companyDetails,
    isAuthenticated,
    handleRedirectUserToOutgoingCallScreen,
  };
};

export default useQRCodeRedirect;
